export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-copy').forEach(function (el) {
      const copyied_text = el.dataset.content || el.innerHTML
      el.innerHTML =
        el.innerHTML +
        '&nbsp;<span class="copy-icon"><i class="fa fa-copy"></i></span>'
      el.addEventListener('click', function (e) {
        e.preventDefault()
        e.stopPropagation()
        if (window.navigator.clipboard) {
          window.navigator.clipboard.writeText(copyied_text)
          el.querySelector('.copy-icon').innerHTML =
            '<i class="fa fa-check"></i>'
          setTimeout(() => {
            el.querySelector('.copy-icon').innerHTML =
              '<i class="fa fa-copy"></i>'
          }, 3000)
        }
        return false
      })
    })
  })
})()
